var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.103 18.135c.614-2.077 3.916-3.663 7.897-3.663 3.981 0 7.283 1.586 7.897 3.663A9.957 9.957 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 2.312.785 4.441 2.103 6.135ZM12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12Zm0-11a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z",
  fill: "currentColor",
  fillRule: "evenodd"
})));

export { SvgAvatar as ReactComponent };
export default __webpack_public_path__ + "b6332218bfc0017c876545f5051d24ac.svg";